module.exports = __webpack_public_path__ + "img/teaching.da1ca131.svg";